import {Routes} from 'constants/routes';

import Icon from 'components/Icon/Icon';
import Text from 'components/Text/Text';
import {useGlobalState} from 'hooks/useGlobalState';
import {PageEditorsMobile} from 'pages/pub/PageEditorsMobile/PageEditorsMobile';
import {useLocation} from 'react-router';
import './ContactDetails.scss';

interface IProps {
  phone: string;
  email: string;
  website: string;
  facebook: string;
  instagram: string;
  address: string;
  setIsDropdownOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const ContactDetails = ({address, setIsDropdownOpen, phone, email, website, facebook, instagram}: IProps) => {
  const {list: pubEditorsList} = useGlobalState((state) => state.pubPage.pubEditors);

  const {user} = useGlobalState((state) => state.app);
  const {pathname} = useLocation();

  const shouldShowMobilePubPages = !user?.attributes.admin && pathname.includes(Routes.PUB_PAGE);

  return (
    <div className="contact-details">
      <div className="contact-details__info">
        <div className="contact-details__header">
          <Text tag="h4" uppercase className="contact-details__title">
            Contact Details
          </Text>
        </div>

        <div className="contact-details__contacts">
          <div className="contact-details__wrapper">
            {phone && (
              <div className="contact-details__contact">
                <Icon icon="phone" />
                <Text tag="span">{phone}</Text>
              </div>
            )}
            {address && (
              <div className="contact-details__contact">
                <Icon icon="contact-address" />
                <Text tag="span">{address}</Text>
              </div>
            )}
            {email && (
              <div className="contact-details__contact">
                <Icon icon="email" />
                <Text tag="span">{email}</Text>
              </div>
            )}
            {website && (
              <div className="contact-details__contact">
                <Icon icon="web" />
                <Text tag="span">{website}</Text>
              </div>
            )}
          </div>
        </div>
      </div>
      {shouldShowMobilePubPages && (
        <PageEditorsMobile setIsDropdownOpen={setIsDropdownOpen} pubEditors={pubEditorsList} />
      )}
      <div className="contact-details__links">
        <a
          className="contact-details__link"
          style={{pointerEvents: facebook !== '/' ? 'auto' : 'none'}}
          href={`https://${facebook}`}
          rel="noreferrer"
          target="_blank"
          data-testid="facebook-icon"
        >
          <Icon icon="facebook" />
        </a>
        <div className="contact-details__divider" />
        <a
          style={{pointerEvents: instagram !== '/' ? 'auto' : 'none'}}
          className="contact-details__link"
          href={`https://${instagram}`}
          rel="noreferrer"
          target="_blank"
          data-testid="instagram-link-icon"
        >
          <Icon icon="instagram-link" />
        </a>
      </div>
    </div>
  );
};

export default ContactDetails;
